import React, { useState } from "react";
import { toast } from "sonner";
import { Copy, DownloadSimple, Receipt } from "@phosphor-icons/react";
import { DeliveryReceipt } from "@/components/leads/DeliveryReceipt";

const BTN = "border-2 border-black bg-white px-2 py-1 text-[10px] uppercase tracking-widest inline-flex items-center gap-1 transition-colors duration-100 hover:bg-black hover:text-white";
const fmt = (v) => (v === null || v === undefined ? "" : typeof v === "object" ? JSON.stringify(v) : String(v));

// Plain text a client can read in an email: who got it, when, and every field with its value.
export function receiptText(a, firm) {
  const rows = Object.entries(a.sent_payload || {});
  const when = new Date(a.created_at || Date.now()).toLocaleString();
  return [
    `TEST lead sent to ${firm ? `${firm} (${a.destination_name})` : a.destination_name}`,
    `Sent: ${when}`,
    `Result: ${a.status === "delivered" ? "Delivered" : "Not delivered"}${a.response_code ? ` (response ${a.response_code})` : ""}`,
    `${rows.length} fields sent:`, "",
    ...rows.map(([k, v]) => `${k}: ${fmt(v)}`),
  ].join("\n");
}

const copy = (text, what) => navigator.clipboard.writeText(text).then(() => toast.success(`${what} copied`), () => toast.error("Couldn't copy"));

function download(a) {
  const url = URL.createObjectURL(new Blob([JSON.stringify(a.sent_payload, null, 2)], { type: "application/json" }));
  const el = document.createElement("a");
  el.href = url;
  el.download = `test-lead-${String(a.destination_name || "buyer").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "") || "buyer"}.json`;
  el.click();
  URL.revokeObjectURL(url);
}

// Exactly what the buyer's system received on a test send, with ways to share it.
export function TestReceipt({ attempt, firm, testId }) {
  return (
    <div data-testid={testId}>
      <div className="mb-2 flex flex-wrap gap-1.5">
        <button type="button" className={BTN} onClick={() => copy(receiptText(attempt, firm), "Receipt")} data-testid={`${testId}-copy-text`}>
          <Copy size={11} weight="bold" /> Copy for the client
        </button>
        <button type="button" className={BTN} onClick={() => copy(JSON.stringify(attempt.sent_payload, null, 2), "JSON")} data-testid={`${testId}-copy-json`}>
          <Copy size={11} weight="bold" /> Copy JSON
        </button>
        <button type="button" className={BTN} onClick={() => download(attempt)} data-testid={`${testId}-download`}>
          <DownloadSimple size={11} weight="bold" /> Download JSON
        </button>
      </div>
      <DeliveryReceipt attempt={{ ...attempt, id: testId }} />
    </div>
  );
}

export function ReceiptToggle({ attempt, firm, testId }) {
  const [open, setOpen] = useState(false);
  if (!attempt.sent_payload) return null;
  const n = Object.keys(attempt.sent_payload).length;
  const label = attempt.status === "delivered" ? `See what ${attempt.destination_name} got` : `See what we tried to send ${attempt.destination_name}`;
  return (
    <div className="mt-1.5">
      <button type="button" className={BTN} onClick={() => setOpen((o) => !o)} data-testid={`${testId}-toggle`}>
        <Receipt size={11} weight="bold" /> {open ? "Hide what they got" : `${label} (${n} fields)`}
      </button>
      {open && <div className="mt-2 border border-black bg-white p-2"><TestReceipt attempt={attempt} firm={firm} testId={testId} /></div>}
    </div>
  );
}
